/***
 * 客户价值分析
 */
import { post, get, postJson, put } from '../axios'
const RESOURCE_BASE_PATH = '/rfm-analyse'

// 消费频次
export const consumptionFrequency = p => get(`${RESOURCE_BASE_PATH}/consumptionFrequency`, p);

// 消费能力
export const consumptionCapacity = p => get(`${RESOURCE_BASE_PATH}/consumptionCapacity`, p);

// 导出数据
export const exportData = p => get(`${RESOURCE_BASE_PATH}/consumptionFrequencyAndCapacity/export`, p);

// 客户分析自定义参数配置
export const analysiSave = p => postJson(`/customer-analysis/config/save`, p);

// 客户分析自定义参数配置
export const analysiconfigs = p => get(`/customer-analysis/configs`, p);


//导出数据
export const exportDataOne = p => get(`/rfm-analyse/consumptionFrequencyAndCapacity/export?${p}`);

